import React, {Suspense} from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Switch, useRouteMatch } from 'react-router';
import CmpAppConfiguration from "../../pages/publisher/cmp/CmpAppConfiguration";
import CmpAppGroupConfiguration from "../../pages/publisher/cmp/CmpAppGroupConfiguration";
import CmpDefaultPublisherConfiguration from "../../pages/publisher/cmp/CmpDefaultPublisherConfiguration";

function CmpConfiguration(props) {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Suspense fallback={<div>{t('loading')}...</div>}>
      <Switch>
        <Route exact path={path} component={CmpDefaultPublisherConfiguration}/>
        <Route path={`apps/:appId/${path}`} component={CmpAppConfiguration}/>
        <Route path={`apps/groups/:appGroupId/${path}`} component={CmpAppGroupConfiguration}/>
      </Switch>
    </Suspense>
  )
}

export default CmpConfiguration
